var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"compare-navigation__item-switcher",class:_vm.getSwitchStatus ? _vm.getSwitchColor[_vm.activeColor] : '',on:{"click":_vm.onSwitch}})}
var staticRenderFns = []

export { render, staticRenderFns }